import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Placeholder Icons
const PhoneIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"></path></svg>
);
const EmailIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path></svg>
);
const LocationIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg>
);
const CopyIcon = () => ( // Simple Copy Icon
    <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
);
const CheckIcon = () => ( // Simple Check Icon for feedback
    <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
);


const contactInfo = [
    { Icon: PhoneIcon, title: "Call Us", text: "+91 79860 569", href: "tel:+9876543210", copyable: true }, // Mark as copyable
    { Icon: EmailIcon, title: "Email HR", text: "hr@forceapp.com", href: "mailto:hr@forceapp.com", copyable: true }, // Mark as copyable
    { 
        Icon: LocationIcon, 
        title: "Visit Us", 
        text: "2nd Floor Building no. 216, scheme no. 78-part 2, vijay nagar- 452010", 
        href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("2nd Floor Building no. 216 scheme no. 78-part 2, vijay nagar- 452010")}`,
        copyable: false // Location is not copyable by default click
    },
];

// --- Google Forms Configuration (Replace Placeholders!) ---
// 1. Replace this URL with your actual Google Form's Action URL
const GOOGLE_FORM_ACTION_URL = "YOUR_GOOGLE_FORM_ACTION_URL_HERE"; 

// 2. Replace these entry IDs with the ones from your Google Form 
//    (Inspect the live form's HTML source to find names like 'entry.123456789')
const GOOGLE_FORM_FIELD_MAP = {
    name: "entry.YOUR_NAME_FIELD_ID",
    _replyto: "entry.YOUR_EMAIL_FIELD_ID", 
    phone: "entry.YOUR_PHONE_FIELD_ID",
    company: "entry.YOUR_COMPANY_FIELD_ID",
    message: "entry.YOUR_MESSAGE_FIELD_ID",
};
// --- End Google Forms Configuration ---

function Contact() {
    // State for form data, submission status, and messages
    const initialFormData = { name: '', _replyto: '', phone: '', company: '', message: '' };
    const [formData, setFormData] = useState(initialFormData);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState(null); // { type: 'success' | 'error', text: string } | null
    const [copiedIndex, setCopiedIndex] = useState(null); // Track which item is copied

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
        // Clear message on new input
        if (submitMessage) setSubmitMessage(null); 
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage(null);

        // Create FormData for Google Forms
        const formDataForGoogle = new FormData();
        formDataForGoogle.append(GOOGLE_FORM_FIELD_MAP.name, formData.name);
        formDataForGoogle.append(GOOGLE_FORM_FIELD_MAP._replyto, formData._replyto);
        formDataForGoogle.append(GOOGLE_FORM_FIELD_MAP.phone, formData.phone);
        formDataForGoogle.append(GOOGLE_FORM_FIELD_MAP.company, formData.company);
        formDataForGoogle.append(GOOGLE_FORM_FIELD_MAP.message, formData.message);

        try {
            // IMPORTANT: Replace GOOGLE_FORM_ACTION_URL with your actual URL
            if (GOOGLE_FORM_ACTION_URL === "YOUR_GOOGLE_FORM_ACTION_URL_HERE") {
                console.error("Google Form URL not replaced!");
                setSubmitMessage({ type: 'error', text: 'Form not configured. Please contact support.' });
                setIsSubmitting(false);
                return; // Stop submission if URL is not set
            }

            await fetch(GOOGLE_FORM_ACTION_URL, {
                method: 'POST',
                mode: 'no-cors', // Important for sending to Google Forms from browser
                body: formDataForGoogle,
            });

            // Assume success after sending (due to no-cors mode)
            setSubmitMessage({ type: 'success', text: 'Message sent successfully! Thank you.' });
            setFormData(initialFormData); // Clear form

        } catch (error) {
            console.error("Form submission error:", error);
            setSubmitMessage({ type: 'error', text: 'A network error occurred. Please check your connection and try again.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    // Function to handle copying text
    const handleCopy = (textToCopy, index) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopiedIndex(index); // Set the copied index
            setTimeout(() => setCopiedIndex(null), 2000); // Clear after 2 seconds
        }).catch(err => {
            console.error('Failed to copy: ', err);
            // Optionally show an error message to the user
        });
    };

    // Restore Variants
    const sectionFadeUp = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut", staggerChildren: 0.1 }
        }
    };
    const itemVariant = { 
        hidden: { opacity: 0, y: 20 }, 
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } 
    };
    const inputFocusVariant = { scale: 1.02 };

    return (
        <motion.section // Restore motion.section
            id="contact" 
            className="py-24 bg-gradient-to-br from-gray-50 to-white"
            variants={sectionFadeUp} // Restore props
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }} 
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header Layout */}
                <div // Keep this as a regular div
                    className="mb-16 md:grid md:grid-cols-2 md:gap-8 md:items-start"
                >
                    {/* Restore motion elements for header items */}
                    <motion.div variants={itemVariant}> 
                        <span className="text-primary font-semibold tracking-wider uppercase block mb-2">Contact Us</span>
                        <h2 className="text-4xl font-bold text-gray-900 mt-1">Get In Touch</h2>
                    </motion.div>
                    <motion.p variants={itemVariant} className="mt-4 text-lg text-gray-600 md:mt-0"> 
                        Have questions about our services? Ready to start your digital transformation journey? Let's talk.
                    </motion.p>
                </div>

                {/* Contact Info Grid */}
                <motion.div // Restore motion.div
                    variants={itemVariant} 
                    className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
                >
                    {contactInfo.map((info, index) => {
                        const isCopied = copiedIndex === index;
                        // Restore motion button/a tag based on copyable flag
                        const WrapperComponent = info.copyable ? motion.button : motion.a; 
                        const commonProps = {
                            key: index,
                            className: `block focus:outline-none ${info.copyable ? 'group text-left' : 'hover:no-underline'} focus:ring-2 focus:ring-primary/50 rounded-xl`,
                            "aria-label": `${info.title}: ${info.text}${info.copyable ? ' (Click to copy)' : ''}`,
                            // No variants needed here if parent animates
                        };
                        const wrapperSpecificProps = info.copyable 
                            ? { onClick: () => handleCopy(info.text, index), type: "button" } 
                            : { href: info.href, target: "_blank", rel: "noopener noreferrer" };

                        return (
                            <WrapperComponent {...commonProps} {...wrapperSpecificProps}>
                                <div className="bg-white p-6 rounded-xl shadow-md group-hover:shadow-lg transition-all duration-300 flex items-center">
                                    {/* Restore inner motion elements */} 
                                    <div className="flex-shrink-0 mr-4">
                                        <motion.div // Restore motion.div
                                            whileHover={{ scale: info.copyable ? 1 : 1.1 }} 
                                            className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 text-primary transition-transform duration-300"
                                        >
                                            <info.Icon />
                                        </motion.div>
                                    </div>
                                     <div className="flex-grow">
                                        <div className="flex justify-between items-start mb-1">
                                            <h3 className="text-lg font-semibold text-gray-900">{info.title}</h3>
                                            {info.copyable && (
                                                <motion.button // Restore motion.button
                                                    type="button"
                                                    onClick={(e) => { e.stopPropagation(); handleCopy(info.text, index); }}
                                                    className={`transition-opacity duration-200 text-xs font-medium p-1 rounded ${isCopied ? 'text-green-600 bg-green-100' : 'text-gray-500 opacity-0 group-hover:opacity-100'}`}
                                                    initial={{ opacity: 0 }} // Restore motion props
                                                    animate={{ opacity: isCopied ? 1 : 'inherit' }}
                                                    whileHover={{ opacity: 1 }}
                                                    aria-label={isCopied ? 'Copied' : 'Copy to clipboard'}
                                                >
                                                    {isCopied ? <CheckIcon/> : <CopyIcon/>}
                                                </motion.button>
                                            )}
                                        </div>
                                        <p className={`text-gray-600 text-sm break-words transition-colors duration-200 ${isCopied ? 'text-green-600' : ''}`}>
                                            {isCopied ? 'Copied!' : info.text}
                                        </p>
                                    </div>
                                </div>
                            </WrapperComponent>
                        );
                    })}
                </motion.div>

                {/* Contact Form and Image */}
                <motion.div // Restore motion.div
                    variants={itemVariant} 
                    className="bg-white rounded-2xl shadow-xl overflow-hidden"
                > 
                     <div className="grid grid-cols-1 lg:grid-cols-5">
                        {/* Form Section */}
                        <div 
                            className="p-8 lg:p-12 lg:col-span-3"
                        >
                            <h3 className="text-2xl font-bold mb-6">Send us a message</h3>
                            <form onSubmit={handleSubmit}>
                                {/* Restore motion inputs/textarea */} 
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                                        <motion.input // Restore motion.input
                                            type="text" id="name" name="name" required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                                            placeholder="John Doe"
                                            value={formData.name} onChange={handleChange} disabled={isSubmitting}
                                            whileFocus={inputFocusVariant} // Restore prop
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="_replyto" className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                                        <motion.input // Restore motion.input
                                            type="email" id="_replyto" name="_replyto" required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                                            placeholder="ajay@example.com"
                                            value={formData._replyto} onChange={handleChange} disabled={isSubmitting}
                                            whileFocus={inputFocusVariant} // Restore prop
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                    <div>
                                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                                        <motion.input // Restore motion.input
                                            type="tel" id="phone" name="phone"
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                                            placeholder="+91 98765 43210"
                                            value={formData.phone} onChange={handleChange} disabled={isSubmitting}
                                            whileFocus={inputFocusVariant} // Restore prop
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">Company</label>
                                        <motion.input // Restore motion.input
                                            type="text" id="company" name="company"
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                                            placeholder="Your Company"
                                            value={formData.company} onChange={handleChange} disabled={isSubmitting}
                                            whileFocus={inputFocusVariant} // Restore prop
                                        />
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
                                    <motion.textarea // Restore motion.textarea
                                        id="message" name="message" required rows="5"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                                        placeholder="How can we help you?"
                                        value={formData.message} onChange={handleChange} disabled={isSubmitting}
                                        whileFocus={inputFocusVariant} // Restore prop
                                    ></motion.textarea>
                                </div>
                                
                                {/* Submission Message Area */}
                                {submitMessage && (
                                    <motion.div // Restore motion.div
                                        className={`p-4 mb-4 rounded-md text-sm ${submitMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}
                                        initial={{ opacity: 0, y: 10 }} // Restore props
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -10 }}
                                    >
                                        {submitMessage.text}
                                    </motion.div>
                                )}

                                <div>
                                    <button 
                                        type="submit" 
                                        className={`w-full bg-primary text-white font-semibold px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300 flex justify-center items-center ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                                        disabled={isSubmitting}
                                    >
                                        {/* ... Button content ... */}
                                         {isSubmitting ? (
                                            <>
                                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Sending...
                                            </>
                                        ) : (
                                            'Send Message'
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>

                        {/* Image Section */}
                        <div className="lg:col-span-2 bg-gray-100 relative min-h-[300px] lg:min-h-full">
                          <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url("https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80")` }}
                          ></div>
                          <div className="absolute inset-0 bg-primary/10"></div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </motion.section>
    );
}

export default Contact; 